import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=6ea74f73&scoped=true"
import script from "./BaseFooter.vue?vue&type=script&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&lang=ts"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=6ea74f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea74f73",
  null
  
)

export default component.exports